import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    formControl: {
      width: 145,
      backgroundColor: "#FDFDFD",
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#B9BEC7",
        borderRadius: "8px",
      },
    },
    select: {
      "& .MuiSelect-select": {
        display: "flex",
        flexDirection: "column",
        //padding: "6px 0px 6px 6px",
        padding: "6px",
      },
    },
    upperLabelContainer: {
      display: "flex",
      flexDirection: "column",
    },
    upperLabel: {
      color: "#858FA1",
    },
    lowerLabelContainer: {
      display: "flex",
      alignItems: "center",
      gap: "1px",
      width: "100%",
    },
    lowerLabel: {
      color: "#6B6B6C",
      fontWeight: "500 !important",
    },
    icon: {
      display: "inline-flex",
      pointerEvents: "none",
      marginLeft: "-3px",
    },
    menuProps: {
      backgroundColor: "white",
      "& .MuiMenuItem-root": {
        backgroundColor: "white !important",
        "&:hover": {
          backgroundColor: "#f5f5f5 !important",
        },
        "&.Mui-selected": {
          backgroundColor: "white !important",
          "&:hover": {
            backgroundColor: "#f5f5f5 !important",
          },
        },
      },
    },
    menuItem: {
      color: "#858FA1",
      backgroundColor: "white !important",
      "&:hover": {
        backgroundColor: "#f5f5f5 !important",
      },
      "&.Mui-selected": {
        backgroundColor: "white !important",
        "&:hover": {
          backgroundColor: "#f5f5f5 !important",
        },
      },
    },
  })();
};
